import { createStyles, SimpleGrid, Stack, StackProps } from '@mantine/core';
import { min } from 'lodash/fp';
import React from 'react';

import { ActiveCommandType } from '../../widgets.types';
import { GroupedSwitchesWidgetContextProvider } from './grouped-switches-widget.context';
import { GroupedSwitch, GroupedSwitchProps } from './GroupedSwitch';

export const DEVICE_MAX_GROUPED_SWITCHES_COUNT = 4;

export interface GroupedSwitchesWidgetProps {
  switches: Array<GroupedSwitchProps>;

  deviceState: Record<string, any>;
  activeCommands: Array<ActiveCommandType>;
  onToggle: (
    commandName: string,
    commandParamKey: string,
    isChecked: boolean
  ) => void;

  stackProps?: StackProps;
}

export function GroupedSwitchesWidget({
  switches,

  deviceState,
  activeCommands,
  onToggle,
  stackProps = {},
}: GroupedSwitchesWidgetProps) {
  const { classes, theme } = useStyles();

  return (
    <GroupedSwitchesWidgetContextProvider
      onToggle={onToggle}
      activeCommands={activeCommands}
      deviceState={deviceState}
    >
      <Stack
        className={classes.container}
        p={2}
        spacing="lg"
        pos="relative"
        h="100%"
        w="100%"
        bg="white"
        justify="center"
        {...stackProps}
      >
        <SimpleGrid
          cols={min([switches.length, DEVICE_MAX_GROUPED_SWITCHES_COUNT])}
          w="100%"
          h="100%"
          className={classes.switchesWrapper}
          spacing={theme.spacing.sm}
          p="lg"
        >
          {switches.map((command) => (
            <GroupedSwitch {...command} key={command.key} />
          ))}
        </SimpleGrid>
      </Stack>
    </GroupedSwitchesWidgetContextProvider>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    borderRadius: theme.radius.lg,
  },
  switchesWrapper: {
    overflow: 'auto',
    alignItems: 'center',
  },
}));
